import { getImageLayoutSizes } from '@/utils/nextImage';
import ModalBase from '../ModalBase/ModalBase';
import NextImageView from '../NextImageView/NextImageView';
import styles from './ImageDetailModal.module.scss';

function ImageDetailModal({
  isOpen,
  onClose,
  imageUrl,
  alt = '拡大プレビュー',
}: {
  isOpen: boolean;
  onClose: () => void;
  imageUrl: string | null;
  alt?: string;
}) {
  if (!imageUrl) {
    return null;
  }

  return (
    <ModalBase
      isOpen={isOpen}
      onClose={onClose}
      modalContainerSize='xLarge'
      showBottomCloseButton={false}
      bgColor='transparent'
      closeOnBackgroundClick={true}
    >
      <div className={styles.componentStyle}>
        <NextImageView
          containerClassName={styles.imageContainer}
          src={imageUrl}
          alt={alt}
          fill
          sizes={getImageLayoutSizes({ sp: '95vw', pc: '900px' })}
          objectFit='contain'
        />
      </div>
    </ModalBase>
  );
}

export default ImageDetailModal;
